import React from "react";
import { Button } from "@/components/ui/button";
import { Bell } from "lucide-react";
import { NotificationItem } from "./NotificationItem";

/**
 * Notification dropdown panel
 */
export function NotificationDropdown({ 
  notifications, 
  unreadCount, 
  onMarkAllRead, 
  onNotificationClick 
}) {
  return (
    <div className="absolute right-0 mt-2 w-80 bg-background border border-border shadow-lg z-50">
      {/* Header */}
      <div className="p-3 border-b border-border flex items-center justify-between">
        <h3 className="font-bold">Notifications</h3>
        {unreadCount > 0 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onMarkAllRead}
            className="text-xs"
            data-testid="mark-all-read-btn"
          >
            Mark all read
          </Button>
        )}
      </div>

      {/* Notification List */}
      <div className="max-h-96 overflow-y-auto">
        {notifications.length === 0 ? (
          <EmptyState />
        ) : (
          notifications.slice(0, 10).map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onClick={onNotificationClick}
            />
          ))
        )}
      </div>
    </div>
  );
}

function EmptyState() {
  return (
    <div className="p-6 text-center text-muted-foreground">
      <Bell className="w-8 h-8 mx-auto mb-2 opacity-30" />
      <p className="text-sm">No notifications yet</p>
    </div>
  );
}
